// utils
// const { zeroTime } = rfr('server/lib/helper');
import _ from 'lodash';
import DateFns from 'date-fns';
//const { setHours, setMinutes, setMilliseconds } = require('date-fns');
//import { isBefore, isAfter } = require('date-fns');
import {
  startOfDay,
  endOfDay,
  isBefore,
  isAfter,
  differenceInCalendarDays,
  setHours,
  setMinutes,
  setMilliseconds
} from 'date-fns';
//import {  } = require('date-fns');
import { CALENDAR_TYPE } from '../../../../../../../../../config/calendar_type';
import { TYPE } from '../../../../../../../../../config/prescription_content';
import { PAD_TYPE } from '../../../../../../../../../config/pad';

import getDateTimes from 'app/components/pages/pad-menu/pad-initialization/components/steps/visit-schedule/schedulePrescriptionCalendars/calendarEach/scheduling/getDateTimes';
const scheduleByFirstApplication = function (padPrescription, pad) {
  /*   const Pad = rfr('server/api/pad');
  const pad = new Pad(this.knex, this.currentUser); */

  //const PadPrescription = rfr('server/api/padPrescription');
  //const padPrescription = new PadPrescription(this.knex, this.currentUser);

  /*   const PrescriptionContent = rfr('server/api/prescriptionContent');
  const prescriptionContent = new PrescriptionContent(this.knex, this.currentUser);

  const PrescriptionCalendar = rfr('server/api/prescriptionCalendar');
  const prescriptionCalendar = new PrescriptionCalendar(this.knex, this.currentUser); */

  /*   const Scheduling = rfr(
    'server/api/initializePad/padPrescriptionType/steps/schedulePrescriptionCalendars/calendarEach/scheduling'
  );
  const scheduling = new Scheduling(this.knex, this.currentUser); */

  const {
    // padPrescriptionId,
    //instruction,
    padPrescriptionSuggestionScheduling
    //
  } = padPrescription;

  let [{ applicationDate, applicationTime }] = padPrescriptionSuggestionScheduling;

  // ***************************************************************************
  //                   GET PAD AND PAD_PRESCRIPTION INFORMATION
  // ***************************************************************************

  const { EVERY } = CALENDAR_TYPE;
  //const cPadPrescription = await padPrescription.getByID(padPrescriptionId);

  const calendarType = EVERY;

  let {
    //padId,
    //description,
    type,
    period,
    continuousUse,
    once,
    frequency,
    frequencyTypeId,
    frequencyAmount,
    timeStart,
    timeEnd
    //
  } = padPrescription;

  //let { PADType, startDate, endDate } = await pad.getByID(padId);
  let { PADType, startDate, endDate } = pad;
  const padStartDate = startOfDay(startDate);
  const padEndDate = endOfDay(endDate);

  // ***************************************************************************
  //                           VALIDATE PAD_PRESCRIPTION TYPE
  // ***************************************************************************

  const { SUSTEINED, SUSPENDED, CHANGED_PERIOD } = TYPE;

  const isPadPrescriptionSusteined = type === SUSTEINED;
  const isPadPrescriptionChangedPeriod = type === CHANGED_PERIOD;
  const isPadPrescriptionSuspended = type === SUSPENDED;

  if (isPadPrescriptionSuspended) return;

  // ***************************************************************************
  //                           VALIDATE DATE
  // ***************************************************************************

  const isDateValid = !_.isNil(applicationDate) && _.isDate(new Date(applicationDate));

  if (!isDateValid) {
    /*      throw Errors.PRECONDITION_FAILED([
            {
                key: `initialize_pad__start_date_time_sent_is_not_valid`,
                data: { applicationDate: applicationDate },
            },
        ]); */
  }

  // ***************************************************************************
  //             FIND PRESCRIPTION_CONTENT FROM PAD_PRESCRIPTION ID
  // ***************************************************************************

  //const pContent = await prescriptionContent.getOne({ padPrescriptionId });

  // ***************************************************************************
  //                   DATE TIMES TO SCHEDULE PRESCRIPTION
  // ***************************************************************************

  // let { period, continuousUse, once calendarType, frequency, frequencyTypeId, frequencyAmount, timeStart, timeEnd } = pContent;
  period = continuousUse === 1 ? 30 : period;

  let dateTimes;

  const applyOnlyOnce = once === 1;

  const { RENOVATION, PERFECT_WAVE_PHASE_I_RENOVATION } = PAD_TYPE;
  const isPadRenovation = [RENOVATION, PERFECT_WAVE_PHASE_I_RENOVATION].includes(PADType);

  let firstDateTime = null;

  // Tratamento da data/hora
  const dateObj = DateFns.parse(applicationDate, 'YYYY-MM-DD', new Date());
  const [hours, minutes] = applicationTime.split(':');
  const timeObj = setMilliseconds(setMinutes(setHours(new Date(), hours), minutes), 0);

  const startDateTime =
    DateFns.format(dateObj, 'YYYY-MM-DD') + ' ' + DateFns.format(timeObj, 'HH:mm:ss');

  if (applyOnlyOnce) {
    dateTimes = [new Date(startDateTime)];
  } else {
    if (isPadRenovation && (isPadPrescriptionSusteined || isPadPrescriptionChangedPeriod)) {
      const diff = differenceInCalendarDays(padStartDate, startDateTime);
      const isStartDateTimeBeforePadStartDate = diff > 0;

      if (isStartDateTimeBeforePadStartDate) {
        const nPeriod = diff + period;

        dateTimes = getDateTimes({
          startDateTime,
          period: nPeriod,
          calendarType,
          frequency,
          frequencyTypeId,
          frequencyAmount,
          timeStart,
          timeEnd
        });

        [firstDateTime] = [...dateTimes].filter(
          startDateTime => !isBefore(startOfDay(startDateTime), padStartDate)
        );

        dateTimes = getDateTimes({
          startDateTime: firstDateTime,
          period,
          calendarType,
          frequency,
          frequencyTypeId,
          frequencyAmount,
          timeStart,
          timeEnd
        });
      } else {
        dateTimes = getDateTimes({
          startDateTime,
          period,
          calendarType,
          frequency,
          frequencyTypeId,
          frequencyAmount,
          timeStart,
          timeEnd
        });
      }
    } else {
      dateTimes = getDateTimes({
        startDateTime,
        period,
        calendarType,
        frequency,
        frequencyTypeId,
        frequencyAmount,
        timeStart,
        timeEnd
      });
    }
  }

  dateTimes = [...dateTimes]
    // Removes date that are later than the padEndDate of Pad
    .filter(startDateTime => !isAfter(startOfDay(startDateTime), padEndDate))
    // Removes date that are before than the padStartDate of Pad
    .filter(startDateTime => !isBefore(startOfDay(startDateTime), padStartDate));

  const dateFormated = dateTimes.map(iso => {
    return {
      date: DateFns.format(iso, 'DD/MM/YYYY'),
      time: DateFns.format(iso, 'HH:mm')
    };
  });
  return dateFormated;
};

export default scheduleByFirstApplication;
